import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DiaryNoteService from "../../services/diarynote.service";

export const getDiaryNote = createAsyncThunk(
  "diarynote/getDiaryNote",
  async (payload, thunkAPI) => {
    try {
      const response = await DiaryNoteService.getDiaryNote(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const adddiarynote = createAsyncThunk(
  "diarynote/adddiarynote",
  async (data, thunkAPI) => {
    try {
      const response = await DiaryNoteService.addDiaryNote(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updatediarynote = createAsyncThunk(
  "diarynote/updatediarynote",
  async (payload, thunkAPI) => {
    try {
      const response = await DiaryNoteService.updateDiaryNote(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deletediarynote = createAsyncThunk(
  "diarynote/deletediarynote",
  async (id, thunkAPI) => {
    try {
      const response = await DiaryNoteService.deleteDiaryNote(id);
      return id; 
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  diarynotelist: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const diarynoteSlice = createSlice({
  name: "diarynote",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---------- Get diarynote ---------- */
      .addCase(getDiaryNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDiaryNote.fulfilled, (state, action) => {
        state.loading = false;
        state.diarynotelist = action.payload?.data || [];
      })
      .addCase(getDiaryNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add diarynote ---------- */
      .addCase(adddiarynote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adddiarynote.fulfilled, (state, action) => {
        state.loading = false;
        state.diarynotelist.unshift(action.payload?.data);
      })
      .addCase(adddiarynote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update diarynote ---------- */
      .addCase(updatediarynote.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updatediarynote.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated = action.payload?.data;
        if (updated?._id) {
          const index = state.diarynotelist.findIndex(
            (hw) => hw._id === updated._id
          );
          if (index !== -1) {
            state.diarynotelist[index] = updated;
          }
        }
      })
      .addCase(updatediarynote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
     /* ---------- Delete diarynote ---------- */
.addCase(deletediarynote.pending, (state) => {
  state.loading = true;
  state.error = null;
})

.addCase(deletediarynote.fulfilled, (state, action) => {
  state.loading = false;
  state.diarynotelist = state.diarynotelist.filter(
    (hw) => hw._id !== action.payload
  );
})

.addCase(deletediarynote.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
});

  },
});

export const { resetUpdateStatus } = diarynoteSlice.actions;
export default diarynoteSlice.reducer;
